import { render, staticRenderFns } from "./deliver.vue?vue&type=template&id=7c6d4c77&"
import script from "./deliver.vue?vue&type=script&lang=js&"
export * from "./deliver.vue?vue&type=script&lang=js&"
import style0 from "./deliver.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports